import React from "react"
import {ClientOrgBankAgreement} from "../../../resources/clientOrgBankAgreement"
import OrgRiskSettings from "../RiskSettings/OrgRiskSettings"
import {Org} from "../../../resources/org"
import {Err} from "../../../components/Err/Err"

interface BankNavigationsTabsProps {
	clientOrgBankAgreements: ClientOrgBankAgreement[]
	currentTab: string
	org: Org
	refresh: () => void
	refreshToken: number
}

export function OnboardingRulesNavigationsTabContent({
	clientOrgBankAgreements,
	currentTab,
	org,
	refresh,
	refreshToken,
}: BankNavigationsTabsProps): JSX.Element {
	if (clientOrgBankAgreements.length === 0) {
		return <Err err="No Org Bank Agreement Found." />
	}
	if (clientOrgBankAgreements.length > 1) {
		return (
			<>
				{clientOrgBankAgreements
					.filter(({attributes}) => currentTab === attributes.bankName)
					.map((clientOrgBankAgreement) => (
						<OrgRiskSettings
							key={clientOrgBankAgreement.id}
							agreementId={clientOrgBankAgreement.id}
							org={org}
							bankId={clientOrgBankAgreement.relationships.bank.data.id}
							bankRiskSettings={clientOrgBankAgreement.attributes.bankRiskSettings}
							bankName={clientOrgBankAgreement.attributes.bankName}
							refresh={refresh}
							refreshToken={refreshToken}
						/>
					))}
			</>
		)
	}

	if (currentTab === "Onboarding Rules") {
		const clientOrgBankAgreement = clientOrgBankAgreements[0]
		return (
			<OrgRiskSettings
				agreementId={clientOrgBankAgreement.id}
				org={org}
				bankId={clientOrgBankAgreement.relationships.bank.data.id}
				bankRiskSettings={clientOrgBankAgreement.attributes.bankRiskSettings}
				bankName={clientOrgBankAgreement.attributes.bankName}
				refresh={refresh}
				refreshToken={refreshToken}
			/>
		)
	}

	return <></>
}
